/**
 * @author: leroy
 * @date: 2021/8/28 14:37
 * @description：seo
 */
import Head from 'next/head';
import { useStore } from '@/store/store';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

const SEO = () => {
  const { seoStore, homeStore } = useStore();
  const { title = '', description = '', keywords = '' } = seoStore || {};

  useEffect(() => {
    if (homeStore.examLogoConfig?.is_enterprise_logo) {
      seoStore.setSEO({
        title: homeStore.examLogoConfig?.ico_name,
        // description: homeStore.examLogoConfig?.description,
      });
    }
  }, [homeStore?.examLogoConfig?.is_enterprise_logo]);

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="keywords" content={keywords} />
        <meta name="description" content={description} />
        <meta name="baidu-site-verification" content="code-WT5du8gmXX" />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="https://cdn6.haitou.cc/image/logo-320x320.png" />
      </Head>
    </>
  );
};
export default observer(SEO);
